import * as React from 'react';
import { AppUser } from 'Src/views/App/App';
import * as Promise from 'bluebird';
import { Component } from 'react';
import {
  ColumnDefinition,
  getFilters,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter,
  getPagesCount,
  isFilterExist,
  isSortExist,
  TABLE_SORT_DIRECTION,
} from 'Src/helpers/table';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE } from 'Src/consts/table';
import { parse } from 'query-string';
import { Loader } from 'Src/components/Loader/Loader';
import { Grid } from 'Src/components/Grid/Grid';
import { Package } from '../../../../../../../models/packages';
import {
  addPriceSet,
  deletePriceSet,
  getAllPriceSets,
  getPriceSets,
  getPriceSetsCount,
  updatePriceSet,
} from '../../../../../../../services/superadmin/priceSets';
import { getPackage } from '../../../../../../../services/superadmin/packages';
import { History, Location } from 'history';
import { SimpleModal } from '../../../../../../../components/SimpleModal/SimpleModal';
import { PackagePriceSetForm } from './PackagePriceSetForm/PackagePriceSetForm';
import { getPackagePriceSetProducts, getPackagePriceSetProductsPrice } from '../../../../../../../helpers/accessor';
import { Product } from '../../../../../../../models/products';
import { getProduct } from '../../../../../../../services/superadmin/products';
import { convertToFilterWithPlus } from '../../../../../../../helpers/table';
import { LIMIT } from '../../../../../../../consts/table';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Name',
    field: 'name',
    isSort: true,
    type: FILTER_TYPE.NONE,
    accessor: ['name'],
  },
  {
    text: 'Description',
    field: 'description',
    isSort: true,
    type: FILTER_TYPE.NONE,
    accessor: ['description'],
  },
  {
    text: 'Products',
    field: 'products',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getPackagePriceSetProducts,
  },
  {
    text: 'Price',
    field: 'price',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getPackagePriceSetProductsPrice,
  },
];

interface State {
  items: any[];
  currentPage: number;
  selectedItems: any[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  total: number;
  basePath: string;
  packageItem: Package;
  isPackagePriceSetFormModalOpen: boolean;
  isConfirmationModalOpen: boolean;
  products: Product[];
}

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

export class PackagePriceSets extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      total: 0,
      basePath: '',
      packageItem: undefined,
      isPackagePriceSetFormModalOpen: false,
      isConfirmationModalOpen: false,
      products: [],
    };
  }

  getPackageId(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    const packageId = search.package as string;
    return packageId;
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
    });

    this.setAdditionalItems().then(res => {
      this.setItems();
    });
  }

  setAdditionalItems() {
    const { user } = this.props;
    const packageId = this.getPackageId();

    let packageItem;

    return getPackage(user, packageId)
      .then(_packageItem => {
        packageItem = _packageItem;

        return Promise.all<Product>(packageItem.products.map(product => getProduct(user, product.productId)));
      })
      .then(products => {
        this.setState({
          packageItem: packageItem,
          products: products,
        });

        return true;
      });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true,
      });
      this.setItems();
    }
  }

  setItems() {
    const { history, user } = this.props;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters(COLUMNS, search);

    const isShowFilter = isFilterExist(filters);
    const isDataFiltered = isFilterExist(filters);

    const where = getServerFieldSectionWhere(filters);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter(page, where, order);

    const packageId = this.getPackageId();

    const getItemsPromise = getPriceSets(user, packageId, serverQueryFilter);
    const getItemsCountPromise = getPriceSetsCount(user, packageId, where);

    const promises = [getItemsCountPromise, getItemsPromise];

    return Promise.all(promises).then(([countObj, items]) => {
      this.setState({
        currentPage: page,
        sortDirection: sortDirection as TABLE_SORT_DIRECTION,
        sortColumnsName: sortColumnsName,
        isShowFilter: isShowFilter,
        isDataFiltered: isDataFiltered,
        filters: filters,
        items: items,
        total: countObj.count,
        basePath: history.location.pathname,
        isLoading: false,
      });

      return true;
    });
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const packageId = this.getPackageId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `package=${packageId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated,
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const selectedItemsNext = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: selectedItemsNext,
      isSelectAllChecked: true,
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true,
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters);

    const packageId = this.getPackageId();

    getAllPriceSets(user, packageId, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const selectedItemsNext = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: selectedItemsNext,
        isSelectAllChecked: true,
        isLoading: false,
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const packageId = this.getPackageId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `package=${packageId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue,
            },
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue,
            },
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value,
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue,
        };
      }
    }

    this.setState({
      filters: nextFilters,
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist(filters);

    const filtersConverted = convertToFilterWithPlus(filters);

    if (isFilter) {
      search.push(getSearchFilter(filtersConverted));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });

    const packageId = this.getPackageId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `package=${packageId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });

    const packageId = this.getPackageId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `package=${packageId}`,
      state: history.location.state,
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter,
    });
  };

  goBack = () => {
    const { history, location } = this.props;
    const { state } = location;
    const { search } = state as any;
    const packageId = this.getPackageId();

    history.push({
      pathname: '/packages',
      search: search,
      state: { packageId: packageId },
    });
  };

  onCancelButtonClick = () => {
    this.setState({
      isPackagePriceSetFormModalOpen: false,
    });
  };

  onSubmitForm = data => {
    const { selectedItems, total } = this.state;
    const { user } = this.props;

    const packageId = this.getPackageId();

    this.setState({
      isLoading: true,
    });

    const { products, ...rest } = data;
    const dataToTransfer = {
      ...rest,
      products: products.map(product => {
        return {
          name: product.name,
          productId: product.productId,
          productTypeName: product.productTypeName,
          productTypeId: product.productTypeId,
          productTypeOrder: product.productTypeOrder,
          pricing: {
            deliveryCharge: Number(product.pricing.deliveryCharge),
            price: Number(product.pricing.price),
          },
        };
      }),
    };

    if (selectedItems.length === 1) {
      const priceSet = selectedItems[0];
      const { id } = priceSet;

      updatePriceSet(user, packageId, id, dataToTransfer).then(res => {
        this.setState({
          isPackagePriceSetFormModalOpen: false,
          selectedItems: [res],
          isSelectAllChecked: false,
        });
        this.setItems();
      });
    } else {
      addPriceSet(user, packageId, dataToTransfer).then(res => {
        const lastPage = getPagesCount(total + 1, LIMIT);
        this.setState({
          isPackagePriceSetFormModalOpen: false,
          selectedItems: [res],
          isSelectAllChecked: false,
        });
        this.setCurrentPageParams(lastPage);
        this.setItems();
      });
    }
  };

  renderFormModal(): React.ReactNode {
    const { isPackagePriceSetFormModalOpen, selectedItems, packageItem, products } = this.state;

    if (selectedItems.length === 1) {
      const priceSet = selectedItems[0];
      return (
        <SimpleModal isOpen={isPackagePriceSetFormModalOpen}>
          <PackagePriceSetForm
            priceSet={priceSet}
            packageItem={packageItem}
            onCancel={this.onCancelButtonClick}
            onSubmit={this.onSubmitForm}
            products={products}
          />
        </SimpleModal>
      );
    } else {
      return (
        <SimpleModal isOpen={isPackagePriceSetFormModalOpen}>
          <PackagePriceSetForm
            onCancel={this.onCancelButtonClick}
            packageItem={packageItem}
            onSubmit={this.onSubmitForm}
            products={products}
          />
        </SimpleModal>
      );
    }
  }

  onCreatePriceSetClick = () => {
    this.setState({
      isPackagePriceSetFormModalOpen: true,
    });
  };

  onEditPriceSetClick = () => {
    this.setState({
      isPackagePriceSetFormModalOpen: true,
    });
  };

  showConfirmationModal = () => {
    this.setState({
      isConfirmationModalOpen: true,
    });
  };

  hideConfirmationModal = () => {
    this.setState({
      isConfirmationModalOpen: false,
    });
  };

  renderConfirmationModal(): React.ReactNode {
    const { isConfirmationModalOpen, selectedItems } = this.state;

    return (
      <SimpleModal
        isOpen={isConfirmationModalOpen}
        title={'Confirmation'}
        body={`Are you sure you want to remove ${selectedItems.length === 1 ? 'price set' : 'price sets'}?`}
        buttonText={'Remove'}
        buttonCancelText={'Cancel'}
        onButtonClick={this.onDeletePriceSetClick}
        onCloseClick={this.hideConfirmationModal}
      />
    );
  }

  onDeletePriceSetClick = () => {
    const { selectedItems } = this.state;
    const { user } = this.props;

    this.setState({
      isLoading: true,
      isConfirmationModalOpen: false,
    });

    const packageId = this.getPackageId();

    Promise.all(selectedItems.map(selectedItem => deletePriceSet(user, packageId, selectedItem.id))).then(res => {
      this.setState({
        selectedItems: [],
        isSelectAllChecked: false,
      });

      this.setItems();
    });
  };

  render() {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isLoading,
      isSelectAllChecked,
      currentPage,
      total,
      packageItem,
      isPackagePriceSetFormModalOpen,
      isConfirmationModalOpen,
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes = isPackagePriceSetFormModalOpen || isConfirmationModalOpen ? 'mt-3 modal-open' : 'mt-3';

    const actionItems = [
      {
        itemText: 'Create price set',
        onItemClick: this.onCreatePriceSetClick,
        isActive: selectedItems.length === 0,
      },
      {
        itemText: 'Edit price set',
        onItemClick: this.onEditPriceSetClick,
        isActive: selectedItems.length === 1,
      },
      {
        itemText: selectedItems.length === 1 ? 'Delete price set' : 'Delete price sets',
        onItemClick: this.showConfirmationModal,
        isActive: selectedItems.length > 0,
      },
    ];

    const filterOptions = {};

    const gridTitle = typeof packageItem !== 'undefined' ? `${packageItem.name} / Price sets` : '';

    return (
      <div className={classes}>
        {/*Place for render modal windows*/}
        {this.renderFormModal()}
        {this.renderConfirmationModal()}
        <div className="row">
          <div className="col-md-12">
            <Grid
              dataItems={items}
              filters={filters}
              currentPage={currentPage}
              total={total}
              isSelectAllChecked={isSelectAllChecked}
              isDataFiltered={isDataFiltered}
              sortDirection={sortDirection}
              sortColumnsName={sortColumnsName}
              isShowFilter={isShowFilter}
              dataItemsSelected={selectedItems}
              columns={COLUMNS}
              actionItems={actionItems}
              options={filterOptions}
              onItemClick={this.onItemClick}
              onSortClick={this.onTableSortClick}
              onApplyFilterClick={this.onApplyFilterClick}
              onClearFilterClick={this.onClearFilterClick}
              onTableFilterChange={this.onTableFilterChange}
              onTableFilterClick={this.onTableFilterClick}
              setCurrentPageParams={this.setCurrentPageParams}
              onSelectAllClick={this.onSelectAllClick}
              onSelectAllOnPageClick={this.onSelectAllOnPageClick}
              onUnselectAllClick={this.onUnselectAllClick}
              gridTitle={gridTitle}
              goBack={this.goBack}
            />
          </div>
        </div>
      </div>
    );
  }
}
